const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: "",
  title: "Dev",
};

const about = {
  // all the properties are optional - can be left empty or deleted
  name: "Imer Lopez",
  role: "Computer Science Student and Part-time developer",
  description:
    "I’m interested in web development, mobile development and cyber security",
  resume:
    "https://drive.google.com/file/d/1bXSqKjWYJmkYa9n2hVzPNJBYVKOmM4Ni/view?usp=sharing",
  social: {
    linkedin: "https://linkedin.com/in/imer-lopez-98b39419",
    github: "https://github.com/imerlopez",
  },
};

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  // {
  //   name: "Covid Tracker",
  //   description:
  //     "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
  //   stack: ["Vuejs", "Covid Api", "Vue Chartjs"],
  //   sourceCode: "https://github.com/imerlopez/Covid19",
  //   livePreview: "https://imerlopez.github.io/Covid19/#/",
  // },
  // {
  //   name: 'Project 2',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
  // {
  //   name: 'Project 3',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
];

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  "HTML",
  "CSS",
  "JavaScript",
  "Vuejs",
  "Reactjs",
  "MongoDB",
  "Linux",
  "API",
  "Git",
  "Nodejs",
  "Mysql",
  "Active Directory",
  "Photoshop",
  "Figma",
  "Express",
];

const contact = {
  email: "imerlopez538@gmail.com",
};

export { header, about, projects, skills, contact };
